// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"e5fc4819","107":"7e5bb691","297":"6b63f826","406":"df827347","448":"2b9f3592","628":"b66612ab","886":"7fd356a6"}[chunkId] + ".chunk.js";
};